import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useDeviceType } from '../../../responsive';
import { DateInputMobile } from '../DateInputMobile';
import { DateInputDesktop } from '../DateInputDesktop';

/**
 * Компонент для выбора даты.
 *
 * [Ссылка на макет](https://www.figma.com/design/mZoDyDuh8AcgfMo6a2DsoH/%F0%9F%8C%90-Date-Input)
 *
 * @param {IDateInputProps} props - Свойства компонента.
 * @returns {JSX.Element} Компонент выбора даты.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const DateInput = /*#__PURE__*/React.forwardRef(function DateInput(props, ref) {
  const deviceType = useDeviceType();
  if (deviceType === 'phone') {
    return /*#__PURE__*/_jsx(DateInputMobile, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }));
  }
  return /*#__PURE__*/_jsx(DateInputDesktop, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
});